import type { FC } from 'react';
import React, { useContext } from 'react';
import { StyledParagraph, StyledSubheadline } from '../SubPageNavigationStyles';
import { Context } from '../../../context/Context';

const SubmenuTriggerHeadline: FC = () => {
  const {
    content: { links },
    hasLinks,
    headline,
  } = useContext(Context);
  const subheadline = hasLinks ? links?.find((item) => item.currentPage)?.text : undefined;

  return (
    <div>
      <StyledParagraph
        tag="p"
        variant={{ type: 'copy', order: '2', style: 'bold' }}
        id="headline"
        role="presentation"
      >
        {headline}
      </StyledParagraph>
      {hasLinks && subheadline && subheadline.length > 0 && (
        <StyledSubheadline
          variant={{ type: 'copy', order: '2', style: 'normal' }}
          id="subheadline"
          tag="span"
          role="presentation"
        >
          {subheadline}
        </StyledSubheadline>
      )}
    </div>
  );
};

export default SubmenuTriggerHeadline;
